import createReducer from 'utils/createReducer';
import moment from 'moment';

const today = moment();

const actionTypes = {
  init: 'init',
  setGuestCards: 'setGuestCards',
  setEmployeeGuestCards: 'setEmployeeGuestCards',
  setVisitorGuestCards: 'setVisitorGuestCards',
  setCurrentPage: 'setCurrentPage',
  setTotalPages: 'setTotalPages',
  setCurrentSearch: 'setCurrentSearch',
  setCurrentDate: 'setCurrentDate',
  setCountries: 'setCountries',
  setCities: 'setCities',
  setUniqueFacilitySectors: 'setUniqueFacilitySectors',
  setCurrentCountry: 'setCurrentCountry',
  setCurrentCity: 'setCurrentCity',
  setCurrentFacilitySector: 'setCurrentFacilitySector'
};

const initialState = {
  guestCards: [],
  employeeGuestCards: [],
  visitorGuestCards: [],
  currentPage: 0,
  totalPages: 0,
  currentSearch: '',
  currentDate: today,
  countries: [],
  cities: {},
  uniqueFacilitySectors: {},
  currentCountry: '',
  currentCity: '',
  currentFacilitySector: ''
};

const guestCardsReducer = createReducer(initialState, {
  [actionTypes.init]: () => initialState,
  [actionTypes.setGuestCards]: (state, payload) => ({
    ...state,
    guestCards: payload
  }),
  [actionTypes.setEmployeeGuestCards]: (state, payload) => ({
    ...state,
    employeeGuestCards: payload
  }),
  [actionTypes.setVisitorGuestCards]: (state, payload) => ({
    ...state,
    visitorGuestCards: payload
  }),
  [actionTypes.setCurrentPage]: (state, payload) => ({
    ...state,
    currentPage: payload
  }),
  [actionTypes.setTotalPages]: (state, payload) => ({
    ...state,
    totalPages: payload
  }),
  [actionTypes.setCurrentSearch]: (state, payload) => ({
    ...state,
    currentSearch: payload
  }),
  [actionTypes.setCurrentDate]: (state, payload) => ({
    ...state,
    currentDate: payload
  }),
  [actionTypes.setCountries]: (state, payload) => ({
    ...state,
    countries: payload
  }),
  [actionTypes.setCities]: (state, payload) => ({
    ...state,
    cities: {
      ...state.cities,
      ...Object.keys(payload).reduce(
        (acc, country) => ({
          ...acc,
          [country]: state.cities[country] || payload[country]
        }),
        {}
      )
    }
  }),
  [actionTypes.setUniqueFacilitySectors]: (state, payload) => ({
    ...state,
    uniqueFacilitySectors: {
      ...state.uniqueFacilitySectors,
      ...Object.keys(payload).reduce(
        (acc, city) => ({
          ...acc,
          [city]: state.uniqueFacilitySectors[city] || payload[city]
        }),
        {}
      )
    }
  }),
  [actionTypes.setCurrentCountry]: (state, payload) => ({
    ...state,
    currentCountry: payload
  }),
  [actionTypes.setCurrentCity]: (state, payload) => ({
    ...state,
    currentCity: payload
  }),
  [actionTypes.setCurrentFacilitySector]: (state, payload) => ({
    ...state,
    currentFacilitySector: payload
  })
});

export {actionTypes, guestCardsReducer, initialState};
